<template>

<div>
  <div class="relative">
    <select
      v-model="date_type"
      @change="changeDateType()"
      name="type" id="type" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5">
      <option value="jalali" selected>شمسی</option>
      <option value="gregorian">میلادی</option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z" fill="#64748B"/>
      </svg>

    </div>
  </div>

  <div class="relative">
    <select
      v-model="day"
      name="day" id="day"
      class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5"
    >
      <option value="" disabled selected>روز تولد خود را وارد نمایید</option>
      <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z" fill="#64748B"/>
      </svg>

    </div>
  </div>
  <div class="relative">
    <select
      v-model="month"
      name="month" id="month" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5">
      <option value="" disabled selected>ماه تولد خود را وارد نمایید</option>
      <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z" fill="#64748B"/>
      </svg>

    </div>
  </div>

  <div class="relative">
    <select
      v-model="year"
      name="year" id="year" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200">
      <option value="" disabled selected>سال تولد خود را وارد نمایید</option>
      <option v-for="year in years" :key="year" :value="year">{{ year }}</option>

    </select>
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z" fill="#64748B"/>
      </svg>

    </div>
  </div>
        <div
          class="input-group"
          :style="`display: ${show_error};direction: rtl;font-size: 14px;margin-top: 15px;color: red;text-shadow: 1px 1px #fff;`"
        >
          تاریخ نامعتبر است.
        </div>
        <div
          class="input-group"
          :style="`display: ${show_now_error};direction: rtl;font-size: 14px;margin-top: 15px;color: red;text-shadow: 1px 1px #fff;`"
        >
          چارت آینده در این نسخه در دسترس نیست
        </div>
        <div
          class="input-group"
          :style="`display: ${show_limit_error};direction: rtl;font-size: 14px;margin-top: 15px;color: red;text-shadow: 1px 1px #fff;`"
        >
          امکان محاسبه مومنتوم برای افراد کمتر از 18 سال وجود ندارد
        </div>
</div>

</template>
<script>

import moment from "jalali-moment";
import Autocomplete from "@trevoreyre/autocomplete-vue";

export default {
  name: "DatePicker",
  components: {
    Autocomplete,

  },
  props: {
    limit_future_range: {
      type: Boolean,
      default: true,
    },
    custom_number_fa: {
      type: Number,
      default: 1400,
    },
    custom_number_en: {
      type: Number,
      default: 2020,
    },
    limit_under_18y: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      year_selected: null,
      month_selected: null,
      day_selected: null,
      type_selected: null,
      year: "",
      month: "",
      day: "",
      date_type: "jalali",
      date_locale: "fa",
      date_format: "jYYYY-jMM-jDD",
      days: this.getRange(1, 32, 1),
      months: this.getRange(1, 13, 1),
      years: this.getRange(
        this.limit_future_range ? 1403 : 1450,
        this.limit_future_range ? 1300 : 1000,
        -1
      ),
      show_error: "none",
      show_now_error: "none",
      show_limit_error: "none",
    };
  },
  watch: {
    year: function (value) {
      // let reg = new RegExp('/^(19[5-9]d|20[0-4]d|2050)$/')
      // console.log(reg.test(value))
      // else {
      //   this.year = this.year.substring(0, this.year.length - 1);
      // }
      this.update();
    },
    month: function (value) {
      this.update();
    },
    day: function (value) {
      // if (value < 32 && value > 0 && String(value).length < 3) {
      //   this.day = this.day.substring(0, this.day.length - 1)
      // }
      this.update();
    },
  },
  methods: {
    getRange(start, end, step) {
      return Array.from(
        Array.from(Array(Math.ceil((end - start) / step)).keys()),
        (x) => start + x * step
      );
    },
    changeDateType() {
      // console.log(this.date_type);
      this.show_now_error = "none";
      this.show_limit_error = "none";
      this.show_error = "none";
      if (this.date_type == "jalali") {
        this.date_locale = "fa";
        this.date_format = "jYYYY-jMM-jDD";
        this.years = this.getRange(
          this.limit_future_range ? this.custom_number_fa : 1450,
          this.limit_future_range ? 1300 : 1000,
          -1
        );
      } else {
        this.date_locale = "en";
        this.years = this.getRange(
          this.limit_future_range ? this.custom_number_en : 2100,
          this.limit_future_range ? 1900 : 1200,
          -1
        );
        this.date_format = "YYYY-MM-DD";
      }
    },
    update() {
      if (this.year && this.month && this.day && this.date_type) {
        // console.log(validate_date)
        // console.log("test");
        if (
          moment
            .from(
              `${this.year}-${this.month}-${this.day}`,
              this.date_locale,
              this.date_format
            )
            .isValid()
        ) {
          if (this.limit_under_18y) {
            // changed to limit by 18 years
            // if (this.limit_future_range) {
            var target_date = moment.from(
              `${this.year}-${this.month}-${this.day}`,
              this.date_locale,
              this.date_format
            );
            var now = moment().locale(this.date_locale);
            let is_after = false;

            // console.log(target_date);
            // console.log(now);
            // console.log(target_date.diff(now, "days"));

            if (Math.abs(target_date.diff(now, "days")) < 6570) {
              is_after = true;
            }

            if (!is_after) {
              this.show_now_error = "none";
              this.show_limit_error = "none";
              this.show_error = "none";
              this.$emit("updateValidaDateVar", true);
              this.$emit(
                "updateDatePickerForm",
                this.year,
                this.month,
                this.day,
                this.date_type
              );
            } else {
              this.$emit("updateValidaDateVar", false);
              this.show_limit_error = "block";
              this.show_error = "none";
              this.show_now_error = "none";
            }
          } else {
            this.show_now_error = "none";
            this.show_limit_error = "none";
            this.show_error = "none";
            this.$emit("updateValidaDateVar", true);
            this.$emit(
              "updateDatePickerForm",
              this.year,
              this.month,
              this.day,
              this.date_type
            );
          }
        } else {
          this.$emit("updateValidaDateVar", false);
          this.show_limit_error = "none";
          this.show_error = "block";
          this.show_now_error = "none";
        }
      }
    },
  },
};
</script>
<style scoped>
.input-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
}
</style>

